import { render } from "./AppointmentDataFileDataForm.vue?vue&type=template&id=077e8ab6&scoped=true&ts=true"
import script from "./AppointmentDataFileDataForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentDataFileDataForm.vue?vue&type=script&lang=ts"

import "./AppointmentDataFileDataForm.vue?vue&type=style&index=0&id=077e8ab6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077e8ab6"]])

export default __exports__